module.exports = __webpack_public_path__ + "img/icon-plane.6930b603.svg";